export default "__VITE_ASSET__CK66y0Fn__";